import { formatValue } from "../../utils/basic";
export const extractWellValues = (data, settings) => {

    if (!data || !data[1]) {
        // Handle data being null or missing second sub-array
        console.error("Invalid data, please provide a valid data structure.");
        return null;
    }

    const newData = Array.from(data, (v, i) => i === 0 ? v : Object.values(v));

    // const newData = [...data];
    const extractedWellValues = {};
    for (const itemData of newData[1]) {

        const itemName = itemData?.Well;

        extractedWellValues[itemName] = {}; // Initialize empty object for each item
        for (const setting of settings) {
            // Check if setting exists in itemData
            if (setting?.value in itemData) {
                // Handle "events" and other simple settings separately
                // Avoiding ternary here for readability
                //   if (typeof itemData[setting] !== "object") {
                //     extractedWellValues[itemName][setting] = itemData[setting];
                //  } else {
                // Assign entire object for settings with nested values
                extractedWellValues[itemName][setting?.value] = itemData[setting?.value];
                //   }
            } else { // Default value for missing settings
                extractedWellValues[itemName][setting?.value] = null;
            }
        }
    }
    return extractedWellValues;
}

export const formatWellValues = (wellDataObject, channels) => {

    const allWellsFormattedData = [];
    //Loop over each wellId and wellData in the wellDataObject

    for (const [wellId, wellData] of Object.entries(wellDataObject)) {

        const formattedWellData = {
            wellId,
            acceptedEvents: formatValue(wellData["Accepted Events"]),
            rejectedEventsPercent: formatValue(wellData["% Rejected events"]),
            acceptedWidthCV: formatValue(wellData["Accepted Width CV%"]),
            clusteringDataQuality: formatValue(wellData["Clustering Data Quality"]),
            totalEvents: formatValue(wellData["Total Events"]),
            widthMean: formatValue(wellData["Width Mean"]),
            widthSigma: formatValue(wellData["Width sigma"]),
            sampleName: wellData["sample_name"],
        };

        // Add dynamic channel properties
        channels.forEach(channel => {
            formattedWellData[`amplitudeCV${channel}`] = formatValue(wellData["Amplitude CV %"]?.[channel]);
            formattedWellData[`amplitudeMean${channel}`] = formatValue(wellData["Amplitude mean"]?.[channel]);
            formattedWellData[`concentration${channel}`] = formatValue(wellData["Concentration (cp/uL)"]?.[channel]);
            formattedWellData[`meanNegativeAmplitude${channel}`] = formatValue(wellData["Mean negative amplitude"]?.[channel]);
            formattedWellData[`meanPositiveAmplitude${channel}`] = formatValue(wellData["Mean positive amplitude"]?.[channel]);
            formattedWellData[`meanPositiveNegativeAmplitudeRatio${channel}`] =
                formatValue(wellData["Mean positive/negative amplitude ratio"]?.[channel]);
            formattedWellData[`polydispersity${channel}`] = formatValue(wellData["Polydispersity"]?.[channel]);
            formattedWellData[`polydispersityRevB${channel}`] = formatValue(wellData["Polydispersity Rev B"]?.[channel]);
            formattedWellData[`rainMiddlePercent${channel}`] = formatValue(wellData["Rain, Middle %"]?.[channel]);
            formattedWellData[`sValue${channel}`] = formatValue(wellData["S Value"]?.[channel]);
            formattedWellData[`thresholdDataQuality${channel}`] = formatValue(wellData["Threshold data quality"]?.[channel]);
            formattedWellData[`thresholdValue${channel}`] = formatValue(wellData["Threshold value"]?.[channel]);
            // ... any other properties that depend on the channel
        });

        allWellsFormattedData.push(formattedWellData);
    }

    return allWellsFormattedData;
};


export const processPlateDataForSelction = (plateData, selectedValue) => {
    if (plateData) {
        const plateLevelData = [];
        for (const [key, value] of plateData) {

            if (key === selectedValue) {
                plateLevelData.push(value);
            }
        }

        return plateLevelData;
    } else {
        console.error("Invalid data, please provide a valid data structure.");
        return null;
    }
};

// matches the API response to the selection
export const selectionKeyMap = (channels) => ({

    //dual mappings
    'Amplitude mean': { type: 'dual', channel0: `amplitudeMean${channels[0]}`, channel1: `amplitudeMean${channels[1]}` },
    'Concentration (cp/uL)': { type: 'dual', channel0: `concentration${channels[0]}`, channel1: `concentration${channels[1]}` },
    'Mean negative amplitude': { type: 'dual', channel0: `meanNegativeAmplitude${channels[0]}`, channel1: `meanNegativeAmplitude${channels[1]}` },
    'Mean positive amplitude': { type: 'dual', channel0: `meanPositiveAmplitude${channels[0]}`, channel1: `meanPositiveAmplitude${channels[1]}` },
    'Mean positive/negative amplitude ratio': {
        type: 'dual', channel0: `meanPositiveNegativeAmplitudeRatio${channels[0]}`,
        channel1: `meanPositiveNegativeAmplitudeRatio${channels[1]}`
    },
    'Polydispersity': { type: 'dual', channel0: `polydispersity${channels[0]}`, channel1: `polydispersity${channels[1]}` },
    'Polydispersity Rev B': { type: 'dual', channel0: `polydispersityRevB${channels[0]}`, channel1: `polydispersityRevB${channels[1]}` },
    'Rain, Middle %': { type: 'dual', channel0: `rainMiddlePercent${channels[0]}`, channel1: `rainMiddlePercent${channels[1]}` },
    'S Value': {
        type: 'dual', channel0: `sValue${channels[0]}`, channel1: `sValue${channels[1]}`
    },
    'Threshold data quality': { type: 'dual', channel0: `thresholdDataQuality${channels[0]}`, channel1: `thresholdDataQuality${channels[1]}` },
    'Threshold value': { type: 'dual', channel0: `thresholdValue${channels[0]}`, channel1: `thresholdValue${channels[1]}` },
    'Amplitude CV %': { type: 'dual', channel0: `amplitudeCV${channels[0]}`, channel1: `amplitudeCV${channels[1]}` },
    //single mappings
    'Accepted Width CV%': { type: 'single', key: 'acceptedWidthCV' },
    'Clustering Data Quality': { type: 'single', key: 'clusteringDataQuality' },
    'Accepted Events': { type: 'single', key: 'acceptedEvents' },
    '% Rejected events': { type: 'single', key: 'rejectedEventsPercent' },
    'Total Events': { type: 'single', key: 'totalEvents' },
    'Width Mean': { type: 'single', key: 'widthMean' },
    'Width sigma': { type: 'single', key: 'widthSigma' },
    'sample_name': { type: 'single', key: 'sampleName' }
});


export const processWellDataForSelection = (formattedWellValues, selection, channels) => {

    const processedData = {};

    const maps = selectionKeyMap(channels);

    formattedWellValues.forEach(well => {

        // const mapping = selectionKeyMap[selection];
        const mapping = maps[selection];

        if (mapping && mapping.type === 'dual') {
            // Handle the case with FAM and VIC/HEX values
            processedData[well.wellId] = {
                [channels[0]]: well[mapping.channel0],
                [channels[1]]: well[mapping.channel1]
            };
        } else if (mapping && mapping.type === 'single') {
            // Handle general cases with a single value
            processedData[well.wellId] = well[mapping.key];
        } else {
            // Fallback or default handling
            processedData[well.wellId] = well[selection];
        }
    });

    return processedData;
};

export const getChannelColors = (channel) => {
    const channelColors = {
        'FAM': 'bg-[rgb(2,119,189)]',
        'HEX': 'bg-[rgb(255,152,0)]',
        'VIC': 'bg-[rgb(255,193,7)]',
    };

    return channelColors[channel];
};

